/** «JELLY ZIMMERMAN ENTERPRISE» → «JZ»: las dos primeras palabras, sin signos. */
export function nameInitials(name) {
  return String(name || "")
    .replace(/[^\p{L}\p{N}\s]/gu, " ")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join("")
    .toUpperCase();
}
